import { useEffect } from "react";

const APP_NAME = "Market Enginuity AI Sales Toolkit";

export function usePageTitle(pageTitle: string) {
  useEffect(() => {
    document.title = pageTitle ? `${APP_NAME} - ${pageTitle}` : APP_NAME;
    
    return () => {
      document.title = APP_NAME;
    };
  }, [pageTitle]);
}
